exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.manager-dashboard{display:flex;flex-direction:column;height:100%;width:100%}.manager-dashboard .dashboard-body{display:flex;flex-direction:column;height:calc(100% - 76px);position:relative}.manager-dashboard .dashboard-body .tabs-container{position:absolute;top:0;left:0;height:56px;width:100%;border-top:1px solid #000}.manager-dashboard .dashboard-body .tabbed-view-container{width:100%;height:calc(100% - 56px);position:absolute;top:56px}.manager-dashboard .dashboard-body.dashboard-body--single-dashboard-tab .tabs-container{height:0;border-top:none;overflow:hidden}.manager-dashboard .dashboard-body.dashboard-body--single-dashboard-tab .tabbed-view-container{top:0;height:100%}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/ManagerDashboard/ManagerDashboard.scss
// module id = 1745
// module chunks = 0